<div class="jurisdiction-empty-state">
  <div class="jurisdiction-empty-state__icon">
    <i class="mdi" [ngClass]="icon" aria-hidden="true"></i>
  </div>
  <h5 class="jurisdiction-empty-state__title">{{ title }}</h5>
  @if (message) {
    <p class="jurisdiction-empty-state__text">{{ message }}</p>
  }
  @if (actionLabel) {
    @if (actionLink) {
      <a class="btn btn-sm btn-outline-primary" [routerLink]="actionLink">{{ actionLabel }}</a>
    } @else {
      <button class="btn btn-sm btn-outline-primary" type="button" (click)="action.emit()">
        {{ actionLabel }}
      </button>
    }
  }
</div>
